import 'bootstrap/dist/css/bootstrap.css';
import Col from 'react-bootstrap/Col';

const asideC = () => {
    return (  
        <Col md="4" h="50" id='aside'>
            <h2>Nasi fundatorzy:</h2>
            <ul>
                <li>Kreecik3</li>
                <li>miksonek12</li>
                <li>Rafal9797</li>
            </ul>
        </Col>
    );
}
 
export default asideC;